import { apiRequest, ApiError } from '@/integrations/api/client';
import { isExpaiApiEnabled } from '@/integrations/api/config';

export interface AgentChatResult {
  reply: string;
  ui_actions: unknown[];
  tool_calls: Array<{ name: string; args: Record<string, unknown> }>;
  model: string;
}

export interface AgentChatBody {
  messages: Array<{ role: 'user' | 'assistant' | 'system'; content: string }>;
  screen_context?: { route?: string; filters?: Record<string, unknown>; selectedEntity?: Record<string, unknown> | null };
  user_role?: string;
}

// Once the backend reports Gemini is not configured (503), stop hitting it for
// the rest of the session and let the local fallback brain answer.
let backendDisabled = false;

export function isAgentBackendAvailable(): boolean {
  return isExpaiApiEnabled() && !backendDisabled;
}

export async function agentChat(body: AgentChatBody): Promise<AgentChatResult> {
  try {
    return await apiRequest<AgentChatResult>('/api/agent/chat', { method: 'POST', body });
  } catch (err) {
    // 503 = Gemini not configured on the server → disable for the session.
    if (err instanceof ApiError && err.status === 503) {
      backendDisabled = true;
    }
    throw err;
  }
}
